export const EventSiteInfoWrapCss = {
  mainContainer: {
    backgroundColor: "#12222d",
    color: "#fff",
    paddingTop: "90px",
    paddingBottom: "90px"
  }
};
